import { Controller } from "@hotwired/stimulus"

// The tab links load their tab into the `settings_panel` Turbo frame and advance the URL, so
// content, reload and back/forward are all Turbo's. The navigation sits outside the frame,
// though, and Turbo's back/forward restores only the frame — so the highlight follows the
// panel: every panel that connects (a click, a history restore, the first load) names its tab.
// The click handler moves it at once instead of after the response arrives — but only for a
// click Turbo will actually follow, and it moves back if the request fails.
export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    this.restore = () => {
      if (this.hasPanelTarget) this.highlight(this.panelTarget.dataset.tab)
    }
    this.element.addEventListener("turbo:fetch-request-error", this.restore)
  }

  disconnect() {
    this.element.removeEventListener("turbo:fetch-request-error", this.restore)
  }

  switch(event) {
    // A dirty guard declined the switch, or a modified/middle click opens the tab elsewhere:
    // the panel stays, so the highlight must too.
    if (event.defaultPrevented || event.button > 0) return
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return

    this.highlight(event.currentTarget.dataset.tab)
  }

  panelTargetConnected(panel) {
    this.highlight(panel.dataset.tab)
  }

  highlight(tabName) {
    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.tab === tabName
      tab.classList.toggle("bg-green-500", active)
      tab.classList.toggle("text-white", active)
      tab.classList.toggle("text-gray-500", !active)
      tab.classList.toggle("hover:text-gray-700", !active)
      tab.classList.toggle("hover:bg-gray-100", !active)
      if (active) {
        tab.setAttribute("aria-current", "page")
      } else {
        tab.removeAttribute("aria-current")
      }
    })
  }
}
